import React from 'react';
import { FileText, Search, FileBadge, ClipboardCheck, ShieldCheck } from 'lucide-react';

const stepIcons = [FileText, Search, FileBadge, ClipboardCheck, ShieldCheck];

const SDProcessSection = ({ content }) => {
  if (!content.process || content.process.length === 0) return null;

  return (
    <section className="py-24 bg-white" data-testid="sd-process-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="eyebrow mb-4">How It Works</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter mb-4">
            Your {content.title} Journey
          </h2>
          <p className="font-body text-base text-[#4A5D53] max-w-2xl mx-auto leading-relaxed">
            Our streamlined process makes {content.title.toLowerCase()} easy and efficient
          </p>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-${Math.min(content.process.length, 5)} gap-8`}>
          {content.process.map((step, index) => {
            const IconComponent = stepIcons[index % stepIcons.length];
            return (
              <div key={index} className="relative text-center group cursor-pointer p-8 rounded-3xl transition-all duration-300 hover:bg-[#F9F8F6] hover:shadow-lg hover:-translate-y-2" data-testid={`process-step-${index}`}>
                <div className="flex justify-center mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#C85A40] flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                    <IconComponent className="h-7 w-7 text-white" strokeWidth={1.5} />
                  </div>
                </div>
                <h3 className="font-display text-xl font-bold text-[#111C16] mb-3 transition-colors duration-300 group-hover:text-[#C85A40]">{step.title}</h3>
                <p className="font-body text-sm text-[#4A5D53] leading-relaxed max-w-xs mx-auto">{step.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SDProcessSection;
